<template>
  <div>
    <SenditTable
      :headers="headers"
      :registers="registers"
      :loading="loading"
      :itemsPerPage="itemsPerPage"
      :currentPage="currentPage"
      :totalPages="10"
      pagination
      selectable
      expandable
      expandText="Detalhes"
      searchable
      searchPlaceholder="Search"
      :searchTime="1500"
      @updatePage="atualizandoPage"
      @selectRow="selecionarLinha"
      @search="search"
    >
      <template #filters-left>
        <CDropdown
          color="transparent"
          :toggler-text="$t('general.components.table.headerActions.dropdown.manage-contacts')"
          class="text-gray-500"
          addTogglerClasses="p-0 "
        >
          <template slot="toggler">
            <div class="text-gray-600 py-2 dropdown__header d-flex align-items-center" :class="{ 'text-gray-700': statePopUpManage == true }">
              <CIcon name="manage" size="custom-size" :height="21" viewBox="0 0 32 32" />
              <span class="mx-2">{{ $t('general.components.table.headerActions.dropdown.manage-contacts') }}</span>
              <CIcon name="arrow" size="custom-size" :height="15" viewBox="0 0 32 32" />
            </div>
          </template>
          <CDropdownItem class="text-decoration-none" @click.stop="goToPage('import-history')">{{
            $t('general.components.table.headerActions.dropdown.import-historic')
          }}</CDropdownItem>
          <CDropdownItem class="text-decoration-none" @click.stop="goToPage('custom-fields')">{{
            $t('general.components.table.headerActions.dropdown.custom-fields')
          }}</CDropdownItem>
          <CDropdownItem v-show="Boolean(totalRecords)" class="text-decoration-none" @click.stop="openPopUpComponent('export')"
            >{{ $t('general.components.table.headerActions.dropdown.export') }} {{ typeName }}</CDropdownItem
          >
          <CDropdownItem v-show="Boolean(totalRecords)" class="text-decoration-none" @click.stop="openPopUpComponent('deleteAll')"
            >{{ $t('general.components.table.headerActions.dropdown.delete-all') }} {{ typeName }}</CDropdownItem
          >
        </CDropdown>
      </template>

      <template #filters-center> Demonstração </template>

      <template #filters-right>
        <CDropdown
          color="transparent"
          :toggler-text="$t('general.components.table.headerActions.dropdown.manage-contacts')"
          class="text-gray-500"
          addTogglerClasses="p-0"
        >
          <template slot="toggler">
            <div class="text-gray-600 py-2" :class="{ 'text-gray-700': statePopUpManage == true }">
              <CIcon name="manage" size="custom-size" :height="21" viewBox="0 0 32 32" />
              <span class="mx-2">{{ $t('general.components.table.headerActions.dropdown.manage-contacts') }}</span>
              <CIcon name="arrow" size="custom-size" :height="15" viewBox="0 0 32 32" />
            </div>
          </template>
          <CDropdownItem class="text-decoration-none" @click.stop="goToPage('import-history')">{{
            $t('general.components.table.headerActions.dropdown.import-historic')
          }}</CDropdownItem>
          <CDropdownItem class="text-decoration-none" @click.stop="goToPage('custom-fields')">{{
            $t('general.components.table.headerActions.dropdown.custom-fields')
          }}</CDropdownItem>
          <CDropdownItem v-show="Boolean(totalRecords)" class="text-decoration-none" @click.stop="openPopUpComponent('export')"
            >{{ $t('general.components.table.headerActions.dropdown.export') }} {{ typeName }}</CDropdownItem
          >
          <CDropdownItem v-show="Boolean(totalRecords)" class="text-decoration-none" @click.stop="openPopUpComponent('deleteAll')"
            >{{ $t('general.components.table.headerActions.dropdown.delete-all') }} {{ typeName }}</CDropdownItem
          >
        </CDropdown>
      </template>

      <template #search-left>
        <h3 class="font-weight-normal text-gray-600 mt-3 d-flex align-items-sm-center">
          {{ 10 }}
          <span class="font-sm font-weight-normal text-uppercase ml-2">Demonstração</span>
        </h3>
      </template>

      <template #search-right>
        <router-link class="btn btn-primary px-5 py-3 font-weight-bold" tag="button" :to="{ name: 'users-invite' }">Ação</router-link>
      </template>

      <template #expanded-area="{ item }">
        <div class="py-3 px-4 bg-gray-200 text-gray-600">
          {{ item }}
        </div>
      </template>
    </SenditTable>
  </div>
</template>

<script>
const headerLabel = [
  { key: 'dateTime', label: 'DATE' },
  { key: 'createdBy', label: 'USER' },
  { key: 'typeName', label: 'ACTION' },
  { key: 'channel', label: 'CHANNEL' },
  { key: 'transactionAmount', label: 'VALUE' },
  { key: 'balance', label: 'BALANCE' },
  // {
  //   key: 'showDetails',
  //   label: '',
  //   _classes: 'hidde',
  //   _style: 'width:150px',
  // },
]

const mockList = [
  {
    dateTime: new Date().toISOString(),
    createdBy: 'Alexandra Ribeiro',
    typeName: 'Buy pack 50 SMS',
    channel: 'SMS - Portugal',
    transactionAmount: 50,
    balance: 21091,
    metaData: 'Buy pack 50 SMS',
  },
  {
    dateTime: new Date().toISOString(),
    createdBy: 'Rafael Fransisco',
    typeName: 'Buy pack 10.000 Emails',
    channel: 'Email',
    transactionAmount: 10000,
    balance: 16921,
    metaData: 'Buy pack 10.000 Emails',
  },
  {
    dateTime: new Date().toISOString(),
    createdBy: 'Carlos Santos',
    typeName: 'Campaign Sent',
    channel: 'SMS - Spain',
    transactionAmount: -12091,
    balance: 6034,
    metaData: null,
  },
]

import SenditTable from './SenditTable.vue'

export default {
  components: {
    SenditTable,
  },
  data() {
    return {
      registers: mockList,
      headers: headerLabel,
      itemsPerPage: 10,
      currentPage: 1,
      loading: false,
      selectedItems: [],
    }
  },
  methods: {
    atualizandoPage(currentPage) {
      this.getData()
      this.currentPage = currentPage
    },
    getData() {
      this.loading = true
      setTimeout(() => {
        this.registers = mockList.reverse()
        this.loading = false
      }, 2000)
    },
    selecionarLinha(linha) {
      this.selectedItems = linha
    },
    search(value) {},
  },
}
</script>

<style></style>
